import { Flower2 } from "lucide-react";
import { MARQUEE_WORDS } from "@/data/content";

export const Marquee = () => (
  <section data-testid="editorial-marquee" aria-hidden className="overflow-hidden border-y border-peach/25 bg-cream-dark py-6">
    <div className="animate-marquee-x flex w-max items-center gap-10">
      {[...MARQUEE_WORDS, ...MARQUEE_WORDS].map((w, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className={`font-display text-4xl uppercase tracking-wider sm:text-5xl ${i % 2 ? "text-outline" : "text-peach-dark"}`}>
            {w}
          </span>
          <Flower2 size={26} className="shrink-0 text-peach" strokeWidth={1.5} />
        </span>
      ))}
    </div>
  </section>
);
